import * as actions from "./actionsTypes";

const initialState = {
  loading: false,
  saveLoading: false,
  formResponses: [],
  formResponsesLength: 0,
  employeeForm: [],
  formQuestions: [],
  error: "",
  formError: "",
};

export default function FormResponsesReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOADING_FORM_RESPONSES:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_FORM_RESPONSES:
      return { ...state, saveLoading: action.payload };

    case actions.GET_FORM_RESPONSES:
      return {
        ...state,
        formResponses: action.payload.responses,
        formResponsesLength: action.payload.responsesLength,
      };

    case actions.GET_EMPLOYEE_FORM:
      return {
        ...state,
        employeeForm: action.payload,
      };

    case actions.GET_FORM_QUESTIONS:
      return {
        ...state,
        formQuestions: action.payload,
      };

    case actions.CREATE_FORM_RESPONSE:
      return {
        ...state,
        saveLoading: false
      };


    case actions.CREATE_FORM_QUESTION:
      return {
        ...state,
        saveLoading: false,
      };

    case actions.EDIT_FORM_QUESTION:
      return {
        ...state,
        saveLoading: false
      };

    case actions.CHANGE_QUESTION_STATUS:
      return {
        ...state,
        saveLoading: false
      };

    case actions.CLEAR_FORM_RESPONSES:
      return {
        ...state,
        formResponses: [],
        formResponsesLength: 0,
      };

    case actions.FORM_RESPONSES_FAIL:
      return { ...state, error: action.payload };
    case actions.FORM_RESPONSES_FORM_FAIL:
      return { ...state, formError: action.payload };
      
    default:
      return state;
  }
}